export enum AmortizationType {
    Type30 = 0,
    Type25 = 1,
    Type20 = 2,
    Type15 = 3,
    TypeIO = 4,
}
